import SHSkeleton, {
  SHSkeletonProps,
} from "@components/design-systems/sh-skeleton";

export const StepBadgeSkeleton = ({ ...others }: SHSkeletonProps) => {
  return <SHSkeleton height={32} width={120} variant={"rounded"} {...others} />;
};
